import type { SeoLocationDetails } from '@rover/rsdk/src/apiClient/latest/model/seoLocationDetails';

export default function getMetaDescription(seoLocationDetails: SeoLocationDetails): string {
  if (seoLocationDetails && seoLocationDetails.seoMetaDescription !== '') {
    return seoLocationDetails.seoMetaDescription;
  }
  return `Find the best ${seoLocationDetails.serviceTypeName} in ${seoLocationDetails.name} from our network of trusted local sitters. ${seoLocationDetails.numberOfReviews} pet parents in your area have booked on Rover and given their sitters a 5-star review.`;
}
